import type { FaireProductEntity } from "../../entity_types/product";

export const p_hdf8ywgeg7: FaireProductEntity = {
  token: "p_hdf8ywgeg7",
  type: "product",
  name: "Organic Wool Crew Socks",
  brandToken: "b_dtik0xdswq",
  brandName: "Maggie's Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/f3fcf6a33c8c03412b25acb7c22673a54027134a4949606ab2499b360d44caf0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f8a828132cd792dfc354d890cfc0b0a7444499e004585557ddd5e1159dedd8af.jpeg",
    "https://cdn.faire.com/fastly/6e7a7eed0957597809c94d43a9f016366e046eccfc071140dc55f68129e4b134.jpeg",
    "https://cdn.faire.com/fastly/d2ba9dc27590fef0fb02fa1944553b68a9c038bdd9230ca11279aae87edf4ce7.jpeg",
    "https://cdn.faire.com/fastly/aa866c3889db92d9fccac1b274679c698a340ac1f397e7c60d107d5bb3522055.webp",
  ],
  priceDollars: 12.5,
  description:
    "Washable organic merino wool meets classic crew comfort. Relaxed fit, mid-weight, with mid-calf height. Everyday wear for all of your occasions.",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:31.290Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
